import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { Http } from '@angular/http';
import { RequestBuilder } from '../classes/request-builder';
import { Observable } from 'rxjs';
import * as Enum from '../utils/enums';

@Injectable()
export class GestioneAllegatiService extends BaseService {

  /**
   * Costruttore
   * @param http Servizio di richieste HTTP 
   */
  constructor(http: Http) {
    super(http);
  }

  /**
   * Get list of allegati
   * @param reqBuilder 
   */
  getAllAllegati(reqBuilder?: RequestBuilder): Observable<any> {
    let payload
    if (reqBuilder) {
      payload = reqBuilder
    }
    return this.doPost('allegatoutente/fetch', payload, Enum.CONTENT_TYPE_ENUM.APPLICATION_JSON)
  }

  /**
   * upload file
   * @param file 
   * @param nomeFile 
   * @param descrizioneAllegato 
   * @param idCommessa 
   */
  uploadAllegato(file: any, nomeFile: string, descrizioneAllegato: string, idCommessa: string): Observable<any> {
    return this.doUploadDestinatario('allegatoutente/save', file, Enum.CONTENT_TYPE_ENUM.APPLICATION_OCTET_STREAM, nomeFile, descrizioneAllegato, idCommessa)
  }


  /**
   * Get list of aziende 
   * true = esecutori
   * false= aggiudicatari
   * @param reqBuilder 
   */
  fetchAziende(reqBuilder?: RequestBuilder) {
    let payload
    if (reqBuilder) {
      payload = reqBuilder
    }
    return this.doPost('allegatoutente/fetchaziende', payload, Enum.CONTENT_TYPE_ENUM.APPLICATION_JSON)

  }

  /**
   * visualizzazione allegato 
   */
  visualizzaAllegato(reqBuilder: RequestBuilder): Observable<any> {
    return this.doPost('allegatoutente/visualizzaallegato', reqBuilder, Enum.CONTENT_TYPE_ENUM.APPLICATION_JSON)
  }

  convalidaLettura(reqBuilder?: RequestBuilder) {
    let payload
    if (reqBuilder) {
      payload = reqBuilder
    }
    return this.doPost('allegatoutente/ConfermaLettura', payload, Enum.CONTENT_TYPE_ENUM.APPLICATION_JSON)

  }

  /**
   * delete allegato
   * @param reqBuilder 
   */
  deleteAllegato(reqBuilder?: RequestBuilder): Observable<any> {
    let payload
    if (reqBuilder) {
      payload = reqBuilder
    }
    return this.doPost('allegatoutente/delete', payload, Enum.CONTENT_TYPE_ENUM.APPLICATION_JSON)
  }
}
